import { render, staticRenderFns } from "./FRQView.vue?vue&type=template&id=52d194de&"
import script from "./FRQView.vue?vue&type=script&lang=js&"
export * from "./FRQView.vue?vue&type=script&lang=js&"
import style0 from "./FRQView.vue?vue&type=style&index=0&id=52d194de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports